import { CONFIG_ENV, CUSTOMER_APP_URL } from '@m/config/env';
import { getCollectEndpoint, getCookieDomainForUrl } from '@m/utils/rwgConversion';

import type { RwgConfig } from '@m/utils/rwgConversion';

/** SOCi Conversion Partner ID. Public, and constant across environments. */
const RWG_CONVERSION_PARTNER_ID = '20003524';

/**
 * Reserve with Google config for the customer app, sourced from the app's own environment
 * (`REACT_APP_CONFIG_ENV`, `REACT_APP_CUSTOMER_APP_URL`) rather than sniffed from the hostname.
 * The marketing app builds the equivalent from its `NEXT_PUBLIC_*` vars.
 */
export const RWG_CONFIG: RwgConfig = {
  collectEndpoint: getCollectEndpoint(CONFIG_ENV === 'production'),
  cookieDomain: getCookieDomainForUrl(CUSTOMER_APP_URL),
  conversionPartnerId: RWG_CONVERSION_PARTNER_ID,
};
